module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/sample/sample.component.scss
// module id = ./src/app/main/content/sample/sample.component.scss
// module chunks = main